var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldOfDypians(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261161406"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1434",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_1855_946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WOD",
    d: "M18.4831 6.48047H14.9303H11.16V29.8805H22.8335V26.0359H26.64V16.4245L18.4831 6.48047ZM22.8335 25.999H14.9666V10.362H16.7067L22.8335 17.8293V25.999Z",
    fill: "#F7F7FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_946",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5690FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C56FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldOfDypians);
export default __webpack_public_path__ + "static/media/world-of-dypians.a80c7981c526efa61715d96139c9bd40.svg";
export { ForwardRef as ReactComponent };